import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'SkeletonLine',
  props: {
    dark: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { dark: boolean }


const className = computed<string>(() => props.dark ? 'pulse-dark' : 'pulse');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-full h-15 overflow-hidden rounded-sm", _unref(className)]),
    "aria-hidden": "true"
  }, null, 2))
}
}

})